export const ROUTE_BY_PRODUCT = {
  toy: '/toy?new=true',
  story: '/story?new=true',
  animation: '/animation?new=true',
};

export const PRODUCT_OFFERING_CTA_FALLBACK = [
  { productType: 'toy', name: '', nameEn: null, href: ROUTE_BY_PRODUCT.toy },
  { productType: 'story', name: '', nameEn: null, href: ROUTE_BY_PRODUCT.story },
  { productType: 'animation', name: '', nameEn: null, href: ROUTE_BY_PRODUCT.animation },
];

export function offeringLabel(offering, language, i18nFallback) {
  const fromAdmin =
    language === 'fa' ? (offering.name ?? '') : (offering.nameEn ?? '');
  const trimmed = String(fromAdmin).trim();
  return trimmed || i18nFallback;
}

export function selectProductOfferingCtas(rows) {
  return [...rows]
    .filter((row) => Object.prototype.hasOwnProperty.call(ROUTE_BY_PRODUCT, row.productType))
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map((row) => ({
      productType: row.productType,
      name: (row.name ?? '').trim(),
      nameEn: row.nameEn == null ? null : String(row.nameEn).trim() || null,
      href: ROUTE_BY_PRODUCT[row.productType],
    }));
}

/** Published unlocked ConversionServices → front CTAs at `/s/:slug`. */
export function mapPublishedCustomCtas(services) {
  return [...services]
    .filter((row) => typeof row.slug === 'string' && row.slug.trim())
    .map((row) => ({
      productType: 'custom',
      slug: row.slug.trim(),
      name: String(row.name ?? row.slug).trim(),
      description: row.description ?? null,
      href: `/s/${encodeURIComponent(row.slug.trim())}?new=true`,
    }));
}

/** Classic ProductOffering trio plus published custom services (additive). */
export function mergeProductOfferingCtas(classicRows, publishedServices) {
  return {
    classic: selectProductOfferingCtas(classicRows),
    custom: mapPublishedCustomCtas(publishedServices),
  };
}
